import { render, staticRenderFns } from "./alipay.vue?vue&type=template&id=9690be9c&scoped=true&"
import script from "./alipay.vue?vue&type=script&lang=js&"
export * from "./alipay.vue?vue&type=script&lang=js&"
import style0 from "./alipay.vue?vue&type=style&index=0&id=9690be9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9690be9c",
  null
  
)

export default component.exports